import React, { useState } from 'react';
import { useTenant } from '../../context/TenantContext';
import SafeIcon from '../../common/SafeIcon';
import { motion, AnimatePresence } from 'framer-motion';

const TenantSwitcher = () => {
  const { tenants, activeTenant, activeTenantId, setActiveTenant } = useTenant();
  const currentTenant = tenants.find(tenant => tenant.id === activeTenantId) || activeTenant;
  const switchTenant = setActiveTenant;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative mb-6 px-4">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-3 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all group"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center text-xl shadow-lg shadow-primary-900/50">
            {currentTenant.logo || '🏢'}
          </div>
          <div className="text-left">
            <p className="text-sm font-bold text-white leading-none mb-1">{currentTenant.name}</p>
            <p className="text-[10px] text-blue-300 font-medium uppercase tracking-wider">{currentTenant.plan}</p>
          </div>
        </div>
        <SafeIcon icon="▼" className={`text-slate-400 w-3 h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
            <motion.div 
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="absolute top-full left-4 right-4 mt-2 bg-slate-800 border border-slate-700 rounded-xl shadow-2xl z-20 overflow-hidden"
            >
              <div className="p-2">
                <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest px-3 py-2">Bytt Kunde (Tenant)</p>
                {tenants.map(tenant => (
                  <button
                    key={tenant.id}
                    onClick={() => {
                      switchTenant(tenant.id);
                      setIsOpen(false);
                    }}
                    className={`w-full flex items-center gap-3 p-3 rounded-lg transition-colors ${currentTenant.id === tenant.id ? 'bg-primary-600 text-white' : 'text-slate-300 hover:bg-slate-700'}`}
                  >
                    <span className="text-lg">{tenant.logo || '🏢'}</span>
                    <div className="text-left flex-1">
                      <p className="text-xs font-bold leading-none">{tenant.name}</p>
                    </div>
                    {currentTenant.id === tenant.id && <SafeIcon icon="✓" className="w-3 h-3" />}
                  </button>
                ))}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default TenantSwitcher;